import axios from 'axios';
import { API_BASE } from '../config/api';

const API = `${API_BASE}/api`;
const CHUNK = 5 * 1024 * 1024;
const DOC_EXT = ['pdf', 'doc', 'docx', 'ppt', 'pptx'];
const IMAGE_EXT = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
const VIDEO_EXT = ['mp4', 'webm', 'mov'];
export const LIMITS_MB = { image: 10, document: 25, video: 500 };
export const ACCEPT = [...IMAGE_EXT, ...VIDEO_EXT, ...DOC_EXT].map((e) => `.${e}`).join(',');

export const kindOf = (file) => {
  const ext = (file.name.split('.').pop() || '').toLowerCase();
  if (IMAGE_EXT.includes(ext)) return 'image';
  if (VIDEO_EXT.includes(ext)) return 'video';
  if (DOC_EXT.includes(ext)) return 'document';
  return null;
};

export const validateFile = (file) => {
  const kind = kindOf(file);
  if (!kind) return 'Use JPG, PNG, GIF, WebP, MP4, WebM, MOV, PDF, Word or PowerPoint files';
  if (file.size > LIMITS_MB[kind] * 1024 * 1024) return `${kind[0].toUpperCase()}${kind.slice(1)}s must be ${LIMITS_MB[kind]} MB or smaller`;
  return null;
};

// Uploads straight from the course editor; the file is also saved to the Media Centre tagged with the course.
export async function uploadCourseMedia(file, { token, courseId, courseTitle, onProgress }) {
  const headers = { Authorization: `Bearer ${token}` };
  const meta = { course_id: courseId || '', course_title: courseTitle || '' };
  if (file.size <= CHUNK) {
    const fd = new FormData();
    fd.append('file', file);
    Object.entries(meta).forEach(([k, v]) => fd.append(k, v));
    const { data } = await axios.post(`${API}/media/upload`, fd, {
      headers, onUploadProgress: (e) => e.total && onProgress?.(Math.round((e.loaded / e.total) * 100)),
    });
    return { ...data, content_type: file.type, size: file.size };
  }
  const total = Math.ceil(file.size / CHUNK);
  const uploadId = `up_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  let last;
  for (let i = 0; i < total; i += 1) {
    const fd = new FormData();
    fd.append('file', file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    fd.append('upload_id', uploadId);
    fd.append('chunk_index', i);
    fd.append('total_chunks', total);
    fd.append('original_filename', file.name);
    fd.append('content_type', file.type || 'application/octet-stream');
    fd.append('total_size', file.size);
    Object.entries(meta).forEach(([k, v]) => fd.append(k, v));
    const { data } = await axios.post(`${API}/media/upload-chunk`, fd, { headers });
    last = data;
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return { ...last, size: file.size };
}

export function parseVideoLink(url) {
  const u = (url || '').trim();
  let m = u.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  if (m) return { provider: 'YouTube', embed_url: `https://www.youtube.com/embed/${m[1]}`, thumb: `https://img.youtube.com/vi/${m[1]}/hqdefault.jpg` };
  m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (m) return { provider: 'Vimeo', embed_url: `https://player.vimeo.com/video/${m[1]}` };
  return null;
}
